import MediBuddyGold from "../assets/MediBuddyGold.svg";

export default function Confirmation() {
    return (
        <div className="bg-white flex flex-col items-center justify-center h-96 space-y-8 px-5 lg:px-16 shadow-lg lg:ml-10 rounded-3xl mt-10 pb-6">
            <img className="w-96" src="" />
            <p className="font-black text-2xl text-center">
                Your request has been registered
                <p>Our team will get back to you soon!</p>
            </p>
        </div>
    );
}
